/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import imageSources from '../../../../../../constants/imageSources/imageSources';

export const PlaceholderDiv = styled.div`
    display: block;
    height: 100px;
    margin: 0 auto;
`;

export const ItemDiv = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100px;
    background: white;
`;

type ColumnElementWrapperProps = {
    openModalBelow: boolean;
    isFirstBlock: boolean;
};

export const ColumnElementWrapper = styled.div<ColumnElementWrapperProps>`
    cursor: default;
    position: absolute;
    padding: 10px;
    width: 194px;
    height: 102px;
    margin: 2px;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0px 0px 4px 0px rgba(28, 28, 28, 0.2);
    color: white;
    left: calc(50% - 56px);
    z-index: 2;
    outline: none;
    margin-top: ${({ openModalBelow, isFirstBlock }) => (openModalBelow ? '100px' : isFirstBlock ? '13px' : '-68px')};
    margin-left: ${({ openModalBelow, isFirstBlock }) =>
        openModalBelow ? '-50px' : isFirstBlock ? '-190px' : '-50px'};
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: center;

    &.close {
        display: none;
        -webkit-transition: opacity 0.4s ease-in-out;
        -moz-transition: opactiy 0.4s ease-in-out;
        -ms-transition: opacity 0.4s ease-in-out;
        -o-transition: opacity 0.4s ease-in-out;
        transition: opacity 0.4s ease-in-out;
    }
    &.open {
        display: flex;
        opacity: 1;
        -webkit-transition: opacity 0.4s ease-in-out;
        -moz-transition: opactiy 0.4s ease-in-out;
        -ms-transition: opacity 0.4s ease-in-out;
        -o-transition: opacity 0.4s ease-in-out;
        transition: opacity 0.4s ease-in-out;
    }
`;

export const IconSpan = styled.span`
    position: absolute;
    top: calc(50% - 16px);
    left: calc(50% - 16px);
`;

type IconDivProps = {
    element: string;
    openModalBelow: boolean;
    isEnabled: boolean;
    borderColor: string;
};

export const IconDiv = styled.div<IconDivProps>`
    display: inline-block;
    background-image: ${({ element }) => `url("${imageSources.ELEMENT_ICONS(element, false)}")`};
    background-repeat: no-repeat;
    background-size: 36px;
    background-position: center;
    width: 36px;
    height: 36px;
    margin: 6px;
    cursor: ${({ isEnabled }) => (isEnabled ? 'pointer' : 'not-allowed')};
    border-radius: 5px;
    box-sizing: border-box;
    :hover {
        border: 1px solid ${({ isEnabled, borderColor }) => (isEnabled ? borderColor : 'transparent')};
    }
`;

type IconProps = {
    displayElementModal: boolean;
};

export const Icon = styled.i<IconProps>`
    cursor: pointer;
    font-size: 24px;
    width: 24px;
    height: 24px;
    padding: 4px;
    color: ${({ theme }) => theme.colors.primary300};
    transform: ${({ displayElementModal }) => (displayElementModal ? 'rotate(45deg)' : 'rotate(0deg)')};
    transition: transform 0.4s ease-out;

    &:hover {
        color: ${({ theme }) => theme.colors.primary700};
    }
`;

export const TooltipSpan = styled.span`
    font-weight: bold;
    width: 20px;
`;

export const PlaceholderDropzoneText = styled.span`
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.neutral900};
    font-weight: 600;
    background: white;
    position: absolute;
    width: 190px;
    height: 32px;
    top: calc(50% - 16px);
    left: calc(50% - 95px);
    padding-top: 5px;
`;

export const ImportDropZoneBackgroundText = styled.span`
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.neutral900};
    width: 256px;
`;

export const ImportDropZoneBackgroundWhiskers = styled.img`
    width: 32px;
    height: 56px;
    transform: rotate(20deg);
    padding-bottom: 26px;
`;

export const ImportDropZoneBackgroundArrow = styled.img`
    width: 170px;
    height: 56px;
    padding-right: 32px;
`;
